module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-cd-abf633166147836fea64a78cac384bbe.svg";